async function show( store, name ) {

  store.setState({

    popup_opened: name

  })

}

async function hide( store ) {

  store.setState({ 
    popup_animate_close: true 
  })

  setTimeout(() => {

    store.setState({ 

      popup_opened: false,
      popup_animate_close: false

    })

  }, 600)

}

export {

  show,
  hide

}